import React from 'react';

import { Checkbox } from '@atlaskit/checkbox';
import DragHandlerIcon from '@atlaskit/icon/glyph/drag-handler';
import Lozenge from '@atlaskit/lozenge';

import { DragItemWrapper } from '@qality/common-components/src/atoms/DragItemWrapper';
import { IssuePriorityIcon } from '@qality/common-components/src/atoms/IssuePriorityIcon';
import { Table } from '@qality/common-components/src/atoms/Table';
import { User } from '@qality/common-components/src/atoms/User/User';
import { Issue } from '@qality/common-components/src/molecules/Issue';
import { RepositoryIssue } from '@qality/common-model';
import { TestCaseRepositoryIssue } from '@qality/common-pages';
import { StatusUtils } from '@qality/common-utils';

import { ColumnsWidths } from '../../TestCaseRepositoryTable';

type Props = { issue: RepositoryIssue; numberOfItems: number };

export function TestCaseRepositoryTableDragOverlayRow({
  issue,
  numberOfItems,
}: Props): JSX.Element {
  return (
    <DragItemWrapper numberOfItems={numberOfItems}>
      <Table>
        <Table.Body>
          <Table.Tr hideOverflow>
            <Table.DndTd isHidden={false} widths={ColumnsWidths.dnd}>
              <Table.ContentHelper alignItems='center'>
                <DragHandlerIcon label='Drag and drop handler icon' />
              </Table.ContentHelper>
            </Table.DndTd>

            <Table.CheckboxTd widths={ColumnsWidths.checkbox}>
              <Table.ContentHelper justifyContent='center' alignItems='center'>
                <Checkbox isChecked={numberOfItems > 0} />
              </Table.ContentHelper>
            </Table.CheckboxTd>

            <Table.Td widths={ColumnsWidths.key}>
              <Table.ContentHelper overflow='hidden'>
                <TestCaseRepositoryIssue issue={issue} />
              </Table.ContentHelper>
            </Table.Td>

            <Table.Td widths={ColumnsWidths.summary}>
              <Table.ContentHelper overflow='hidden'>
                <Issue addPadding title={issue.fields.summary} withEllipsis />
              </Table.ContentHelper>
            </Table.Td>

            <Table.Td widths={ColumnsWidths.project}>
              <Table.ContentHelper overflow='hidden'>
                <Issue
                  title={issue.fields.project.name}
                  iconSrc={issue.fields.project.avatarUrls['16x16']}
                  withEllipsis
                />
              </Table.ContentHelper>
            </Table.Td>

            <Table.Td widths={ColumnsWidths.priority}>
              <Table.ContentHelper justifyContent='center' alignItems='center'>
                <IssuePriorityIcon priority={issue.fields.priority} />
              </Table.ContentHelper>
            </Table.Td>

            <Table.Td widths={ColumnsWidths.status}>
              <Table.ContentHelper alignItems='center'>
                <Lozenge
                  appearance={StatusUtils.getAppearanceType(
                    issue.fields.status.statusCategory.colorName
                  )}
                >
                  {issue.fields.status.name}
                </Lozenge>
              </Table.ContentHelper>
            </Table.Td>

            <Table.Td widths={ColumnsWidths.assignee}>
              <Table.ContentHelper justifyContent='center' alignItems='center'>
                <User
                  userName={issue.fields.assignee?.displayName ?? 'Unassigned'}
                  userAvatar={issue.fields.assignee?.avatarUrls['24x24']}
                  size='small'
                  isTextVisible={false}
                />
              </Table.ContentHelper>
            </Table.Td>

            <Table.Td className='show-on-row-hover' widths={ColumnsWidths.menu}>
              {/* Empty */}
            </Table.Td>
          </Table.Tr>
        </Table.Body>
      </Table>
    </DragItemWrapper>
  );
}
